import { useMemo } from "react";
import * as Yup from "yup";
import { REQUIRED_MESSAGE, stringSchema } from "@/utils/form";
import { CarouselSlide } from "@/components/Common/CarouselForm/CarouselForm";
import { Formik } from "formik";
import { RoleStepSlideForm } from "../RoleStepSlideForm/RoleStepSlideForm";
import { AuthMachineContext } from "@/store/machine/authMachine/authMachine";
import { AuthEventType } from "@/types/auth";
import { waitForever } from "@/utils";
import { XstateForm } from "@/components/Common/XstateForm/XstateForm";
import { trackEvent } from "@/utils/analytics";
import { AnalyticsEventType } from "@/constants/analytics";

export const RoleStepSlide: React.FC<CarouselSlide> = ({ onPrev }) => {
  const authActorRef = AuthMachineContext.useActorRef();
  const initialValues = useMemo(() => {
    return {
      role: undefined
    } as RoleStepFormType;
  }, []);

  return (
    <Formik<RoleStepFormType>
      initialValues={initialValues}
      validationSchema={RoleStepFormSchema}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        trackEvent(AnalyticsEventType.PROVIDER_SELECTED, {
          type: ROLE_OPTIONS.find((option) => option.value === values.role)?.label
        });

        authActorRef.send({
          type: AuthEventType.SET_ROLE,
          value: values.role as string
        });

        return waitForever();
      }}
      validateOnMount={true}
    >
      {(props) => {
        return (
          <XstateForm machineContext={AuthMachineContext}>
            <RoleStepSlideForm {...props} onPrev={onPrev} />
          </XstateForm>
        );
      }}
    </Formik>
  );
};

export type RoleStepFormType = {
  submit: string;
  role?: (typeof ROLE_OPTIONS)[number]["value"];
};

const RoleStepFormSchema = Yup.object().shape({
  role: stringSchema().required(REQUIRED_MESSAGE)
});

export const ROLE_OPTIONS = [
  {
    value: "gpuProvider",
    label: "GPU Provider"
  },
  {
    value: "mlEngineer",
    label: "ML Engineer"
  }
] as const;
